import {Map} from 'immutable';
import {
  SET_LESSON_CARD_DEPTH,
} from '../../actions';

const initialState = new Map({
  cardDepths: new Map(),
});

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_LESSON_CARD_DEPTH:
      return state.setIn(['cardDepths', action.payload.id], action.payload.depth);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/features/shared/reducers/pages/showLessonCard.js